import { PropertiesStats } from "../../actions/appExpandedActions/properties";

const initialState = {
  rentPayments: { docs: [], totalPages: 0 },
  utilityBillPayments: { docs: [], totalPages: 0 },
  propertyFiles: { docs: [], totalPages: 0 },
  propertyCalendar: { docs: [], totalPages: 0 },
  propertyChats: { docs: [], totalPages: 0 },
  propertyQueries: { docs: [], totalPages: 0 },
  propertyInvitations: { docs: [], totalPages: 0 },
  landlordTenantInvitations: { docs: [], totalPages: 0 },
  sharedManagementInvitations: { docs: [], totalPages: 0 },
  propertiesStats: {},
  propertyFolders: { docs: [], totalPages: 0 },
};

const handleNewDocs = (state, payload, key) => {
  if (payload?.page === 1) return payload.docs;

  const existingDocs = state[key]?.docs || [];
  const newDocs = payload?.docs || [];

  const _docs = newDocs.filter(
    (newDoc) => !existingDocs.find((oldDoc) => newDoc._id === oldDoc._id)
  );

  return [...existingDocs, ..._docs];
};

const properties = (state = initialState, { type, payload } = {}) => {
  switch (type) {
    case PropertiesStats.GET_PROPERTIES_AGGREGATED_STATS_SUCCESS:
      return {
        ...state,
        propertiesStats: payload,
      };

    case PropertiesStats.GET_RENT_PAYMENTS_SUCCESS:
      return {
        ...state,
        rentPayments: {
          ...state.rentPayments,
          docs: handleNewDocs(state, payload, "rentPayments"),
          totalPages: payload.totalPages,
        },
      };

    case PropertiesStats.GET_UTILITY_BILL_PAYMENTS_SUCCESS:
      return {
        ...state,
        utilityBillPayments: {
          ...state.utilityBillPayments,
          docs: handleNewDocs(state, payload, "utilityBillPayments"),
          totalPages: payload.totalPages,
          ...(payload?.page === 1 && { stats: payload.stats }),
        },
      };

    // ✅ NEW: Handle utility bill management success actions
    case PropertiesStats.MARK_UTILITY_BILL_AS_PAID_SUCCESS:
      return {
        ...state,
        utilityBillPayments: {
          ...state.utilityBillPayments,
          docs: state.utilityBillPayments.docs.map(bill =>
            bill._id === payload.billId
              ? { ...bill, isPaid: true, status: 'paid', ...payload.updatedBill }
              : bill
          ),
        },
      };

    case PropertiesStats.UPLOAD_UTILITY_BILL_RECEIPT_SUCCESS:
      return {
        ...state,
        utilityBillPayments: {
          ...state.utilityBillPayments,
          docs: state.utilityBillPayments.docs.map(bill =>
            bill._id === payload.billId
              ? { ...bill, receiptUrl: payload.receiptUrl, ...payload.updatedBill }
              : bill
          ),
        },
      };

    case PropertiesStats.GET_PROPERTY_FILES_SUCCESS:
      return {
        ...state,
        propertyFiles: {
          ...state.propertyFiles,
          docs: handleNewDocs(state, payload, "propertyFiles"),
          totalPages: payload.totalPages,
        },
      };

    case PropertiesStats.GET_PROPERTY_CALENDAR_SUCCESS:
      return {
        ...state,
        propertyCalendar: {
          ...state.propertyCalendar,
          docs: handleNewDocs(state, payload, "propertyCalendar"),
          totalPages: payload.totalPages,
        },
      };

    case PropertiesStats.GET_PROPERTY_CHATS_SUCCESS:
      return {
        ...state,
        propertyChats: {
          ...state.propertyChats,
          docs: handleNewDocs(state, payload, "propertyChats"),
          totalPages: payload.totalPages,
        },
      };

    case PropertiesStats.GET_PROPERTY_QUERIES_SUCCESS:
      return {
        ...state,
        propertyQueries: {
          ...state.propertyQueries,
          docs: handleNewDocs(state, payload, "propertyQueries"),
          totalPages: payload.totalPages,
        },
      };

    case PropertiesStats.GET_PROPERTY_INVITATIONS_SUCCESS:
      return {
        ...state,
        propertyInvitations: {
          ...state.propertyInvitations,
          docs: handleNewDocs(state, payload, "propertyInvitations"),
          totalPages: payload.totalPages,
        },
      };

    case PropertiesStats.GET_LANDLORD_TENANT_INVITATIONS_SUCCESS:
      return {
        ...state,
        landlordTenantInvitations: {
          ...state.landlordTenantInvitations,
          docs: handleNewDocs(state, payload, "landlordTenantInvitations"),
          totalPages: payload.totalPages,
        },
      };

    case PropertiesStats.GET_SHARED_MANAGEMENT_INVITATIONS_SUCCESS:
      return {
        ...state,
        sharedManagementInvitations: {
          ...state.sharedManagementInvitations,
          docs: handleNewDocs(state, payload, "sharedManagementInvitations"),
          totalPages: payload.totalPages,
        },
      };

    case PropertiesStats.GET_PROPERTY_FOLDERS_SUCCESS:
      return {
        ...state,
        propertyFolders: {
          ...state.propertyFolders,
          docs: handleNewDocs(state, payload, "propertyFolders"),
          totalPages: payload.totalPages,
        },
      };

    default:
      return state;
  }
};

export default properties;